import "./App.scss";
import block from "bem-cn";
import IDTable from "../IDTable/IDTable";
import Filter from "../Filter/Filter";
import Auth from "../Auth/Auth";
import { columns } from "../../config/columns";
import { data, prepareData } from "../../utils/response";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectFilterBusy, selectFilterTags } from "../Filter/FilterSlice";
import {
  fetchDataFromServer,
  selectDevelopers,
  selectStatus,
  setBooking,
  setSignIn,
  setSignUp,
} from "./AppSlice";

import { useLocation } from "react-router-dom";
import { routes } from "../../routes";
import DevListPopup from "../DevListPopup/DevListPopup";
import WindowShower from "../WindowShower/WindowShower";
import { getUniqueTags } from "./App.utils";
import { useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import Avatar from "../Avatar/Avatar";

const b = block("App");

const App = () => {
  const tags = useAppSelector(selectFilterTags);
  const busy = useAppSelector(selectFilterBusy);

  const dispatch = useAppDispatch();

  const { pathname } = useLocation();
  const isAuth = pathname === routes.test.auth;
  dispatch(setSignUp(pathname === routes.signUp));
  dispatch(setSignIn(pathname === routes.signIn));
  dispatch(setBooking(pathname === routes.booking));

  const developers = useAppSelector(selectDevelopers);
  const status = useAppSelector(selectStatus);

  useEffect(() => {
    dispatch(fetchDataFromServer());
  }, [dispatch]);

  // console.log(process.env.NODE_ENV);

  return (
    <div className={b()}>
      <Auth isAuth={isAuth} />

      <Filter tags={tags} whitelist={getUniqueTags(data)} />
      <div>{status}</div>
      <div className={b("wrapper")}>
        <div className={b("tables")}>
          <IDTable
            filterValue={tags}
            filterBusy={busy}
            type={"Разработчики"}
            columns={columns}
            // data={prepareData(data)}
            data={developers}
            isAuth={isAuth}
          />
        </div>
        <DevListPopup />
      </div>
      <WindowShower />
    </div>
  );
};

export default App;
